<app-home [titre]="title"
          [homeApplication]="null"
          [menu]="menu"
          [anonymous]="false"
          [avatar]="false"
          [showAccessibility]="showAccessibility"
          [miniSidenav]="false"
          [darkTheme]="false" version="3.2.2">
</app-home>
<p8-spinner></p8-spinner>

